/**
 * Open external http(s) links in a new tab with noopener/noreferrer.
 * Uses URL origin (covers eu.example.com vs example.com and scheme/port).
 * Capture-phase click + MutationObserver so footer/menus and late-injected links still work.
 * data-external-links="same-tab" opts out.
 */
(function () {
	"use strict";

	function applyToAnchor(a) {
		if (!a || a.getAttribute("data-external-links") === "same-tab") return;
		const href = a.getAttribute("href");
		if (!href || href.trim().startsWith("#")) return;
		let url;
		try {
			url = new URL(a.href, window.location.href);
		} catch {
			return;
		}
		if (url.protocol !== "http:" && url.protocol !== "https:") return;
		if (url.origin === window.location.origin) return;
		a.target = "_blank";
		if (a.relList) {
			a.relList.add("noopener");
			a.relList.add("noreferrer");
		} else {
			a.setAttribute("rel", "noopener noreferrer");
		}
	}

	function enhance() {
		const links = document.links;
		for (let i = 0, n = links.length; i < n; i++) {
			applyToAnchor(links[i]);
		}
	}

	function onDocumentClick(e) {
		const el = e.target;
		if (!el || !el.closest) return;
		const a = el.closest("a[href]");
		if (!a) return;
		applyToAnchor(a);
	}

	let debounceId;
	function scheduleEnhance() {
		clearTimeout(debounceId);
		debounceId = setTimeout(enhance, 50);
	}

	function initObserver() {
		if (typeof MutationObserver === "undefined" || !document.body) return;
		new MutationObserver(scheduleEnhance).observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	function boot() {
		enhance();
		initObserver();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}
	document.addEventListener("shopify:section:load", enhance);
	document.addEventListener("click", onDocumentClick, true);
})();
